import { render, staticRenderFns } from "./CareInstruction.vue?vue&type=template&id=1a447fac&scoped=true&"
import script from "./CareInstruction.vue?vue&type=script&lang=js&"
export * from "./CareInstruction.vue?vue&type=script&lang=js&"
import style0 from "./CareInstruction.vue?vue&type=style&index=0&id=1a447fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a447fac",
  null
  
)

export default component.exports